import Controller from "controllers/application_controller"

export default class extends Controller {
  static identifier = "ui-filter-group"
  static targets = ["applied", "option", "template"]

  connect() {
    this.syncOptions()
    this.addEventListener(this.element, "filter:remove", () => this.syncOptions())
  }

  add({ currentTarget }) {
    const key = currentTarget.dataset.uiFilterGroupFilterKey
    if (!key) return

    const template = this.templateFor(key)
    if (!template) return

    this.appliedTarget.appendChild(template.content.cloneNode(true))

    this.syncOptions()
    this.activateFilter(key)

    this.element.dispatchEvent(new CustomEvent("filter:added", {
      detail: { key },
      bubbles: true
    }))
  }

  syncOptions() {
    const appliedKeys = this.appliedKeys()

    this.optionTargets.forEach(option => {
      const key = option.dataset.uiFilterGroupFilterKey
      option.hidden = appliedKeys.has(key)
    })
  }

  appliedKeys() {
    const keys = new Set()
    this.appliedTarget.querySelectorAll("[data-ui-filter-key-value]").forEach(el => {
      keys.add(el.dataset.uiFilterKeyValue)
    })
    return keys
  }

  templateFor(key) {
    return this.templateTargets.find(t => t.dataset.filterKey === key)
  }

  activateFilter(key) {
    const filter = this.appliedTarget.querySelector(`[data-ui-filter-key-value="${key}"]`)
    if (!filter) return

    const select = filter.querySelector(".ui-filter__select-native")
    if (select) {
      select.focus()
      try {
        select.showPicker?.()
      } catch {
        // Native select picker support is browser-controlled.
      }
      return
    }

    const listTrigger = filter.querySelector(".ui-filter__list-trigger")
    if (listTrigger) {
      listTrigger.focus()

      setTimeout(() => {
        const listRoot = listTrigger.closest("[data-controller~='ui-filter-list']")
        const listController = listRoot && this.application.getControllerForElementAndIdentifier(listRoot, "ui-filter-list")

        if (listController) {
          listController.open()
        } else {
          listTrigger.click()
        }
      }, 0)
      return
    }

    this.activateInput(filter)
  }

  activateInput(filter, attempts = 4) {
    // The picker's controllers connect after this turn; opening it sooner
    // would show an empty popover.
    const datePickerTrigger = this.visibleInput(filter, "[data-slot='date-picker-trigger']")
    if (datePickerTrigger) {
      setTimeout(() => datePickerTrigger.click(), 0)
      return
    }

    const textInput = this.visibleInput(filter, "input[type='text']")
    if (textInput) {
      textInput.focus()
      setTimeout(() => textInput.focus(), 0)
      return
    }

    if (attempts > 0) {
      requestAnimationFrame(() => this.activateInput(filter, attempts - 1))
    }
  }

  visibleInput(filter, selector) {
    return [...filter.querySelectorAll(selector)].find(input => input.offsetParent !== null)
  }
}
